import React, { Component } from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loginlogo from './login-logo.png';
import configData from './configData.json';
import { useRef } from 'react';
import cryptojs from 'crypto-js';
import Termsofuse from './Termsofuse.htm';

const Login = () => {
    const [userDetails, setUserDetails] = useState({});
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedPassword, setSelectedPassword] = useState('');
    const [loading, setLoading] = useState(false);

    let userDetailsRef = useRef({});
    userDetailsRef.current = userDetails;

    const navigate = useNavigate();

    // Code for Select UserName on Change
    const selectUserName = (e) => {
        let value = e.target.value;
        var data = value;
        setSelectedUser(data)

    };

    // Code for Select UserName on Change
    const selectPassword = (e) => {
        let value = e.target.value;
        var data = value;
        setSelectedPassword(data)

    };

    const pageLogin = (e) => {
        if (selectedUser === '') {
            document.getElementById("error").innerHTML = "UserName cannot be blank";
            return;
        }

        if (selectedPassword === '') {
            document.getElementById("error").innerHTML = "Password cannot be blank";
            return;
        }

        fetchUserDetails();
        return;
    };

    const fetchUserDetails = async () => {
        debugger;
        setLoading(true);

        let encryptCred = encryptAES(JSON.stringify({
            "username": selectedUser,
            "password": selectedPassword,
            ownerId: 2
        }));

        const userCred = {
            "userCredentials": encryptCred
        };

        const URL = `${configData.BASE_APP_URL}Login/loginencrypt`;
        
        try {
            const resp = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(userCred)
            });

            if (resp.ok) {
                const data = await resp.json();
                setUserDetails(data);
                navigate('/AuthenticationVerify', {
                    state: {
                        loginData: data,
                    },
                });
            } else if (resp.status === 400) {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            // Handle errors here
            console.error('There was an error!', error);
        } finally {
            setLoading(false);
        }
    };

    const getRandom16DigitsInt = () => {
        const factor = 1000000000000000;
        return parseInt(factor + Math.random() * 9 * factor, 10);
    };

    const encryptAES = (value) => {
        debugger;
        const key = getRandom16DigitsInt();
        const iv = getRandom16DigitsInt();

        const text = cryptojs.enc.Utf8.parse(value);

        const encrypted = cryptojs.AES.encrypt(text, cryptojs.enc.Utf8.parse(key), {
            keySize: 128 / 8,
            iv: cryptojs.enc.Utf8.parse(iv),
            mode: cryptojs.mode.CBC,
            padding: cryptojs.pad.Pkcs7,
        });

        const encodedEncrypted = window.btoa(`${key}.${iv}.${encrypted.toString()}`);

        return encodedEncrypted;
    };

    const currentYear = () => {
       return new Date().getFullYear();
    }

    const Loader = () => {
        return (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        )
    }

    return (
        <>
        <div className='login-container shadow-sm bg-body rounded border d-flex'>
            <div className='login-logo d-flex align-items-center justify-content-center p-3 rounded-start'>
                {<img src={loginlogo}></img>}
            </div>
            <div className='login-field d-flex align-items-center p-3'>
                <div>
                    <h3>Login</h3>
                    <p>Sign In to your account</p>
                    <div>
                        <div className="input-group mb-2">
                            <div className="input-group-text rounded-0"><i className="far fa-user"></i></div>
                            <input type="text" className="form-control form-control-sm rounded-0" placeholder="Username" onChange={selectUserName} />
                        </div>
                        <div className="input-group mb-2">
                            <div className="input-group-text rounded-0"><i className="fas fa-lock"></i></div>
                            <input type="password" className="form-control form-control-sm  rounded-0" placeholder="Password" onChange={selectPassword} onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    pageLogin();
                                }
                            }} />
                        </div>
                    </div>
                    <div id="error" className="text-danger"></div>
                    <div className='d-flex justify-content-end align-items-end'>
                        {/* <a href='#'>Forgot Password</a> */}
                        {/* <Button disabled={loading} onClick={pageLogin} className='btn-login p-2 w-25'>Login
                            {loading && <Loader />}
                        </Button> */}
                        <button className="btn-login" type="button" onClick={pageLogin}>
                            {loading && <Loader />} {'  '}
                            Login
                        </button>

                    </div>
                </div>
            </div>
        </div>

        <div>
        <div className="terms-conditions">
            {/* Copyright © 2004 - {currentYear()} <strong>All Rights Reserved. Access and use of this site is subject to the
                <a href={Termsofuse} target="_blank" style={{color: 'cornflowerblue'}}> Terms of Use.</a></strong> */}

<p style={{ color: '#0068BD' }}> <strong>Copyright © 2004 - {new Date().getFullYear()} All Rights Reserved.</strong> By accessing, loading, installing,
                  or using any software technology solutions or services provided by nVision Global Technology
                  Solutions, Inc., you agree to be bound by the <strong><a className="ant-btn-primary" target="_blank" href="https://corporate.nvisionglobal.com/end-user-license-agreement/">Software License</a></strong> and <strong><a target="_blank" href="https://corporate.nvisionglobal.com/terms-of-use/">Terms of Use</a></strong> for this
                  site and all technology provided by nVision Global and affiliated companies.</p>
            </div>
        </div>


        </>

    )
}

export default Login;
